<template>
  <div>
    <heads title="登录"></heads>
    <div class="page">
      <div class="login-content">
        <!-- 左边 -->
        <div class="login-brand" @click="goBackHome">
          <img
            src="@/assets/微信图片_20250221100628.png"
            alt=""
          />
          <!-- <img src="@/assets/Frame 2738.png" alt="" /> -->
          <p>欢迎来到天利38套官方网站。</p>
        </div>

        <!-- 右边 -->
        <div class="login-box">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <lastBar></lastBar>
    <!-- <bottomBar class="bottomBar"></bottomBar> -->
  </div>
</template>

<script setup>
import lastBar from "@/components/lastBar/index.vue";

import heads from "@/components/heads/index.vue";

import { ref, reactive, toRefs, provide } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";

// import bottomBar from "@/components/bottomBar/index.vue";

import { getConfig } from "@/api/list/index.js";

//import phoneNumberLogin from "@/views/login/components/phoneNumberLogin/index.vue";

const router = useRouter();

var mydata = reactive({
  // btnLoading: false,
  // zhanghao: "",
  // mima: "",
  // form: {
  //   username: "",
  //   password: "",
  // },
  // checked1: false,
  // activeName: "first",
  configObj: {},
});

// 获取配置数据
function getConfigFn() {
  getConfig().then((res) => {
    mydata.configObj = res.data;
  });
}

getConfigFn();

// 依赖注入
provide("configObj", toRefs(mydata).configObj);

////////
function goBackHome() {
  router.push({
    path: "/layout/list/home",
  });
}
</script>

<style scoped lang="scss">
.page {
   // width:px;
  // height: 100vh;
  height:calc(100vh - 50px);
  // min-height: 900px;
  // background-image: url("@/assets/logo.png");
  // background-color: #ddeffd !important;
  background: linear-gradient(
    180deg,
    #dce6fc 0%,
    #ffffff 29.94%,
    #dae4fa 73.92%
  );
  overflow: hidden;

  .login-content {
    // height: 467px;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // margin-top: 200px;
    .login-brand {
       display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      margin-top: 27px;
      margin-bottom: 20px;
      cursor: pointer;

      > img:first-of-type {
        display: block;
        width: 200px;
        margin-bottom:20px;
        // height: 54px;
      }
      // > img:last-of-type {
      //   display: block;
      //   width: 256px;
      //   height: 26px;
      //   margin-top: 14px;
      //   margin-bottom: 14px;
      // }
      > p {
        color: #333333;
        font-size: 14px;
        font-weight: 400;
      }
    }

    //登录盒子
    .login-box {
       width: 343px;
      height: 420px;
      margin: 0 auto;

      background-color: #ffffff;
      // border: 1px solid rgb(255, 94, 0);
      border-radius: 8px;
      // padding: 0px 46px !important;
      overflow: hidden;
      box-shadow: 0px 5px 40px 0px #0000000D;
    }
  }
}


:deep(.last-box){
  // border:1px solid red;
  .black-box{
    margin-bottom:0px;
  }
  .white-box{
    display:none !important;
  }
}
</style>
